import { render, staticRenderFns } from "./FormAssignmentSKP.vue?vue&type=template&id=3e8a9e0a&lang=html&"
import script from "./FormAssignmentSKP.vue?vue&type=script&lang=js&"
export * from "./FormAssignmentSKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports